import styled from 'styled-components';
import { motion } from 'framer-motion';
import { User } from 'components/User/UserMeta/Styles'
import { Plug } from 'components/Plug/styles'

// consts
import { UserInfoWidth } from 'defs/Constans'

export const Wrapper = styled(motion.div)`
  display: flex;
  flex-direction: column;
  gap: .8rem;

  height: 100vh;
  justify-content: flex-end;
  position: fixed;
  width: ${UserInfoWidth};
  bottom: 2.4rem;
  right: 3.2rem;

  opacity: 0;
`;

export const Section = styled.section`
  background: ${(props) => props.theme.colors.darkBlue};
  border-radius: 1.2rem;
  padding: 2.4rem;

  ${User} {
    margin-bottom: 2.4rem;
  }

  ${Plug} {
    margin-top: 3.3rem;
  }
`;

export const SectionTitle = styled.div`
  ${(props) => props.theme.fonts.interSemibold24};
  color: ${(props) => props.theme.colors.white100};
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2.4rem;
  margin-top: 1.6rem;
`;

export const Contacts = styled.div`
  padding: 1.2rem 1.6rem;
  background-color: ${(props) => props.theme.colors.lightBlue100};
  border-radius: .8rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: .8rem;
  margin-top: 2.4rem;
`;

export const Username = styled.span`
  ${(props) => props.theme.fonts.interBold13};
  color: ${(props) => props.theme.colors.white100};
  flex: 1;
`;

export const Copy = styled.button`
`;

export const InfoBlock = styled.div`
  display: flex;
  flex-direction: column;
`;

export const InfoTitle = styled.span`
  ${(props) => props.theme.fonts.interSemibold12};
  color: ${(props) => props.theme.colors.secondary};
`;

export const InfoDescription = styled.span`
  ${(props) => props.theme.fonts.interBold18};
  color: ${(props) => props.theme.colors.white100};
  margin-top: .3rem;

  display: flex;
  align-items: center;
  gap: 1.2rem;
`;